export const GET_STORE_LIST = 'GET_STORE_LIST';
export const GET_STORE_LIST_DONE = 'GET_STORE_LIST_DONE';
export const GET_STORE = 'GET_STORE';
export const CREATE_STORE = 'CREATE_STORE';
export const UPDATE_STORE = 'UPDATE_STORE';
export const DELETE_STORE = 'DELETE_STORE';
export const GET_MENU = 'GET_MENU';
export const GET_MENU_LIST = 'GET_MENU_LIST';
export const CREATE_MENU = 'CREATE_MENU';
export const UPDATE_MENU = 'UPDATE_MENU';
export const DELETE_MENU = 'DELETE_MENU';
export const GET_MENU_ITEM_LIST = 'GET_MENU_ITEM_LIST';
export const GET_MENU_TEMPLATE = 'GET_MENU_TEMPLATE';
export const GET_PAYMENT_METHOD_MAPPING = 'GET_PAYMENT_METHOD_MAPPING';
export const GET_PAYMENT_TIMING_MAPPING = 'GET_PAYMENT_TIMING_MAPPING';
export const GET_ORDER_METHOD_MAPPING = 'GET_ORDER_METHOD_MAPPING';

export const PAYMENT_METHOD_MAPPING = [
  {
    key: 'is_cash',
    title: '現金',
  },
  {
    key: 'is_remittance',
    title: '匯款',
  },
];
export const PAYMENT_TIMING_MAPPING = [
  {
    key: 'is_every_month',
    title: '月結',
  },
  {
    key: 'is_instant',
    title: '現結',
  },
  {
    key: 'is_prepaid',
    title: '預繳',
  },
];
export const ORDER_METHOD_MAPPING = [
  {
    title: '電話',
    linkTitle: null,
    icon: 'telephone.svg',
    key: 'phone',
  },
  {
    title: '微碧愛點餐',
    linkTitle: '微碧愛點餐',
    icon: 'iding-logo.svg',
    key: 'iorder_url',
  },
  {
    title: '官方帳號',
    linkTitle: null,
    icon: 'line-logo.svg',
    key: 'line_url',
  },
  {
    title: 'Facebook',
    linkTitle: 'Facebook',
    icon: 'facebook-logo.svg',
    key: 'facebook_url',
  },
];
